import { useFlowSessionById } from "@/api/flow_sessions";
import ChatArea from "@/components/ChatArea";
import HarnessChatArea from "@/components/harness/HarnessChatArea";
import { runsOnHarness } from "@/constants/harnesses";
import { useSessionContext } from "@/context/SessionContext";
import React, { ComponentProps } from "react";

/**
 * The chat area for whatever the session runs on. Sessions stamped with an
 * agent harness (Claude, ChatGPT, OpenCode) render the harness chat set —
 * forked from the originals so the two can diverge — and everything else
 * (legacy loop, sessions predating the stamp, drafts with no session yet)
 * keeps the original components untouched.
 *
 * This is the only dispatch point: hosts mount this, never the pair below.
 */
const SessionChatArea: React.FC<ComponentProps<typeof ChatArea>> = (props) => {
  const { sessionId } = useSessionContext();
  const { data: flowSession } = useFlowSessionById(sessionId ?? "", {
    enabled: !!sessionId,
  });

  return runsOnHarness(flowSession?.harness) ? (
    <HarnessChatArea {...props} />
  ) : (
    <ChatArea {...props} />
  );
};

export default SessionChatArea;
